var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect-item',{attrs:{"id":"instalador","custom-label":_vm.label,"options":_vm.instaladorOptions,"placeholder":"Seleccione instalador","track-by":"id_instaladores","loading":_vm.isLoading},model:{value:(_vm.instalador),callback:function ($$v) {_vm.instalador=$$v},expression:"instalador"}})
}
var staticRenderFns = []

export { render, staticRenderFns }